import Quill from 'quill';
import { RefObject, useEffect } from 'react';

interface QuillEditorRef {
  getQuill?: () => Quill;
}

interface QuillRange {
  index: number;
  length: number;
}

export function useQuillMessageBindings(
  editorRef: RefObject<QuillEditorRef>,
  submitButtonRef: RefObject<HTMLButtonElement>,
): void {
  useEffect(() => {
    const initializeQuillBindings = (): void => {
      const quill: Quill | undefined = editorRef.current?.getQuill?.();
      if (!quill) {
        setTimeout(initializeQuillBindings, 100);
        return;
      }

      quill.clipboard.addMatcher(Node.ELEMENT_NODE, (node, delta) => {
        delta.ops = delta.ops.map((op) => ({
          insert: op.insert,
        }));
        return delta;
      });

      quill.keyboard.bindings.Enter = [];

      quill.keyboard.addBinding(
        {
          key: 13,
          shiftKey: false,
        },
        () => {
          submitButtonRef.current?.click();
          return false;
        },
      );

      quill.keyboard.addBinding(
        {
          key: 13,
          shiftKey: true,
        },
        (range: QuillRange) => {
          const format = quill.getFormat(range.index);

          if (format.list) {
            quill.insertText(range.index, '\n', 'list', format.list, 'user');
          } else {
            quill.insertText(range.index, '\n', 'user');
          }

          quill.setSelection(range.index + 1, 0, 'user');
          return false;
        },
      );
    };

    initializeQuillBindings();
  }, [editorRef, submitButtonRef]);
}
